import React from "react";
import { format, parse, isValid } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CalendarIcon, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const parseBR = (s) => {
  if (!s) return undefined;
  const d = parse(s, "dd/MM/yyyy", new Date());
  return isValid(d) ? d : undefined;
};

export const DatePicker = ({ value, onChange, placeholder = "dd/mm/aaaa", className, testid }) => {
  const [open, setOpen] = React.useState(false);
  const selected = parseBR(value);
  const year = new Date().getFullYear();
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={cn("mt-1 h-11 w-full flex items-center gap-2 rounded-md border border-input bg-background px-3 text-sm text-left hover:bg-accent/40 transition-colors", !value && "text-muted-foreground", className)}>
          <CalendarIcon className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className="flex-1 truncate">{value || placeholder}</span>
          {value && <X className="h-4 w-4 text-muted-foreground hover:text-foreground" onClick={(e) => { e.stopPropagation(); onChange(""); }} data-testid={testid ? `${testid}-clear` : undefined} />}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={ptBR} selected={selected} defaultMonth={selected || new Date()}
          captionLayout="dropdown-buttons" fromYear={year - 10} toYear={year + 5}
          classNames={{ caption_dropdowns: "flex gap-1", dropdown: "rounded-md border border-input bg-background px-1 py-0.5 text-sm", caption_label: "hidden", vhidden: "hidden" }}
          onSelect={(d) => { if (d) onChange(format(d, "dd/MM/yyyy")); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
};
